module.exports = __webpack_public_path__ + "be2615bfd80391bc77e57b666eeb6999.png";